import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

const renderOptions = cities =>
  Object.keys(cities).map(cityName => (
    <option key={cityName} value={cities[cityName]}>
      {cityName}
    </option>
  ));

const CitySelect = ({ currentCity, onCityChange, cities, ...props }) => (
  <select
    value={currentCity}
    onChange={onCityChange}
    data-cy="select-city"
    {...props}
  >
    {!currentCity && (
      <option key="default" value="">
        {trans('home.hero.select_city')}
      </option>
    )}
    {renderOptions(cities)}
  </select>
);
CitySelect.propTypes = {
  currentCity: PropTypes.string,
  onCityChange: PropTypes.func,
  cities: PropTypes.object
};

CitySelect.defaultProps = {
  currentCity: '',
  onCityChange: () => {},
  cities: {}
};

export default CitySelect;
